/*
 * @Author: your name
 * @Date: 2021-07-07 20:30:59
 * @LastEditTime: 2021-07-25 15:41:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \gantt-master\src\task_info.js
 */
import { $, createSVG } from './svg_utils';

export default class Dimension {
    constructor(gantt, task, columns, elheader, elcontent) {
        if (!columns || columns.length == 0) return;
        this.set_defaults(gantt, task, columns, elheader, elcontent);
        this.valueMerges = [];
        this.make_datas();
    }
    /**
     * 初始化默认值
     * @param {*} gantt 整个gantt的属性
     * @param {*} task  任务信息
     * @param {*} columns 左侧的维度字段
     * @param {*} elheader 维度字段表头
     * @param {*} elcontent 维度字段实际内容
     */
    set_defaults(gantt, task, columns, elheader, elcontent) {
        this.text_offset_top = 11; //文字的偏移
        this.gantt = gantt;
        this.task = task;
        this.columns = columns;
        this.$elheader = elheader;
        this.$elcontent = elcontent;
    }

    /**
     * 一列数据输出完后，调整对应的位置
     * @param {*} col 所在字段
     * @param {*} col_x 所在字段的当前占宽的位置
     * @param {*} lines_layer 字段数据所在父级节点
     */
    render_col(col, col_x, parent) {
        let column = this.columns[col];
        let mergelen = this.valueMerges[col].length;
        for (let row = 0; row < mergelen; row++) {
            let value = this.valueMerges[col][row];
            if (value.el) {
                value.lineEl.setAttribute('x2', col_x);
                //判断是否有合并单元格
                if (
                    this.valueMerges[col][row + 1] &&
                    this.valueMerges[col][row + 1].isMerge == true
                ) {
                    let mergeCount = 1;
                    while (
                        this.valueMerges[col][row + mergeCount] &&
                        this.valueMerges[col][row + mergeCount].isMerge == true
                    ) {
                        mergeCount++;
                    }
                    let textpos =
                        parseFloat(value.el.getAttribute('y')) -
                        this.text_offset_top; // 得到基础高
                    textpos += mergeCount * this.row_height / 2 - 16 / 2;
                    // 合并单元格的位置， 行的基本高 + 合并单元格的总高度/2 - 字体高度/2
                    value.el.setAttribute('y', textpos);
                    value.lineEl.setAttribute(
                        'y1',
                        (mergeCount + row) * this.row_height
                    );
                    value.lineEl.setAttribute(
                        'y2',
                        (mergeCount + row) * this.row_height
                    );
                    row += mergeCount - 1;
                }
            }
        }
        // for (let el of parent.querySelectorAll('.col-' + col)) {
        //     //
        //     el.setAttribute('x2', col_x);
        // }
        this.valueMerges[col][0].right_lineEl = createSVG('line', {
            x1: col_x,
            y1: 0,
            x2: col_x,
            y2: this.grid_height,
            class: 'row-line',
            append_to: parent
        });

        this.valueMerges[col][0].header_right_lineEl = createSVG('line', {
            x1: col_x,
            y1: 0,
            x2: col_x,
            y2: 72,
            class: 'row-line',
            append_to: this.$elheader
        });
    }



    make_datas() {
        // 画数据
        const layer = createSVG('g', {
            class: 'content',
            append_to: this.$elcontent
        });

        // 画线
        const lines_layer = createSVG('g', { append_to: this.$elcontent });
        this.grid_height =
            (this.gantt.options.bar_height + this.gantt.options.padding) *
            this.task.length;

        this.row_height =
            this.gantt.options.bar_height + this.gantt.options.padding;
        this.$elcontent.setAttribute('height', this.grid_height);
        this.$elcontent.setAttribute('width', 240);
        const row_width = this.columns.length * 120; //模拟占宽，绘制完成后会重新调整

        let col_x = 0;
        this.col = 0;
        for (let column of this.columns) {
            let row_y = 0;
            let maxwidth = 40;
            let lasttext = null;
            this.valueMerges.push([]);
            let rect = null;
            if (this.task.length != 0) {
                rect = createSVG('rect', {
                    x: col_x,
                    y: row_y,
                    width: row_width,
                    height: this.grid_height,
                    class: 'data-col',
                    append_to: layer
                });
            }

            let row = 0;
            for (let task of this.task) {
                let text = '';
                if (task[column.field]) {
                    text = task[column.field];
                }
                let Merge = this.col == 0 ? null : this.valueMerges[this.col - 1][row];
                let cell = this.make_cell(
                    layer,
                    text,
                    lasttext,
                    col_x,
                    row_y,
                    Merge ? Merge.isMerge : null
                );
                if (cell) {
                    let box = {
                        width: this.gantt.getTextWidth(text)
                    };

                    this.valueMerges[this.col].push({
                        el: cell,
                        // 画底部的线条
                        lineEl: createSVG('line', {
                            x1: col_x,
                            y1: row_y + this.row_height,
                            x2: col_x + maxwidth,
                            y2: row_y + this.row_height,
                            class: 'row-line',
                            append_to: lines_layer
                        }),
                        isMerge: false
                    });
                    maxwidth = box.width > maxwidth ? box.width : maxwidth; //判断当前数据列最大宽度
                } else {
                    this.valueMerges[this.col].push({
                        el: null,
                        isMerge: true
                    });
                }
                row++;
                lasttext = text;
                row_y += this.row_height;
            }
            if (this.task.length == 0) {
                this.valueMerges[this.col] = [{}];
            }
            //写表头
            this.valueMerges[this.col][0].headercell = this.make_cell(
                this.$elheader,
                column.label,
                null,
                col_x,
                18,
                undefined,
                'header-text'
            );
            let box = this.valueMerges[this.col][0].headercell.getBBox();
            maxwidth = box.width > maxwidth ? box.width : maxwidth;
            col_x += maxwidth + 10;
            this.render_col(this.col, col_x, lines_layer);
            rect && rect.setAttribute('width', maxwidth + 10);
            //记录每一列的实际占宽
            this.valueMerges[this.col][0].width = maxwidth + 10;
            this.valueMerges[this.col][0].rectEl = rect;
            this.col++;
        }
        //表头封线
        this.$haderendline = createSVG('line', {
            x1: 0,
            y1: 72,
            x2: col_x,
            y2: 72,
            class: 'row-line',
            append_to: this.$elheader
        });
        // // 最后封线
        // this.$endline = createSVG('line', {
        //     x1: 0,
        //     y1: this.grid_height,
        //     x2: col_x,
        //     y2: this.grid_height,
        //     class: 'row-line',
        //     append_to: lines_layer
        // });
        this.content_width = col_x;
    }
    make_cell(layer, text, lasttext, col_x, row_y, merge, className) {

        let textbasex = 12;
        if (text == '') {
            return createSVG('text', {
                x: col_x + 5,
                y: row_y + this.text_offset_top + textbasex,
                innerHTML: text,
                class: className || 'content-text',
                append_to: layer
            });
        }
        if (text !== lasttext) {
            return createSVG('text', {
                x: col_x + 5,
                y: row_y + this.text_offset_top + textbasex,
                innerHTML: text,
                class: className || 'content-text',
                append_to: layer
            })
        }
        if (merge === false) {
            return createSVG('text', {
                x: col_x + 5,
                y: row_y + this.text_offset_top + textbasex,
                innerHTML: text,
                class: className || 'content-text',
                append_to: layer
            })
        }
    }

    render(width) {
        let coloffset = width / this.col;
        let left = 0;
        let index = 0;
        for (let cols of this.valueMerges) {
            for (let cell of cols) {
                //文字的位置
                if (cell.el) {
                    cell.el.setAttribute('x', left + 5 + coloffset / 2);
                }
                if (cell.headercell) {
                    cell.headercell.setAttribute('x', left + 5 + coloffset / 2);
                }

                //
                if (cell.lineEl) {
                    cell.lineEl.setAttribute('x1', left);
                    cell.lineEl.setAttribute(
                        'x2',
                        left + cols[0].width + coloffset
                    );
                }
                if (cell.right_lineEl) {
                    cell.right_lineEl.setAttribute(
                        'x1',
                        left + cols[0].width + coloffset
                    );
                    cell.right_lineEl.setAttribute(
                        'x2',
                        left + cols[0].width + coloffset
                    );
                }
                if (cell.header_right_lineEl) {
                    cell.header_right_lineEl.setAttribute(
                        'x1',
                        left + cols[0].width + coloffset
                    );
                    cell.header_right_lineEl.setAttribute(
                        'x2',
                        left + cols[0].width + coloffset
                    )
                }

                if (cell.rectEl) {
                    cell.rectEl.setAttribute('x', left);
                    cell.rectEl.setAttribute(
                        'width',
                        cols[0].width + coloffset
                    );
                }
            }

            left += cols[0].width + coloffset;
            index++;
        }
        this.$haderendline.setAttribute('x2', left);
    }
}
